import React from 'react';

function StudyFilters({ filters, setFilters }) {
  const update = (key, value) =>
    setFilters((current) => ({ ...current, [key]: value }));

  return (
    <div className="filter-bar">
      <label>
        Difficulty
        <select
          value={filters.difficulty}
          onChange={(event) => update('difficulty', event.target.value)}
        >
          <option value="">All levels</option>
          <option>Beginner</option>
          <option>Intermediate</option>
          <option>Advanced</option>
        </select>
      </label>

      <label>
        English variant
        <select
          value={filters.variant}
          onChange={(event) => update('variant', event.target.value)}
        >
          <option value="">All variants</option>
          <option value="british">British</option>
          <option value="american">American</option>
        </select>
      </label>
    </div>
  );
}

export default StudyFilters;